'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { activeCurrencySelector } from 'pricing-pages-unified-ui/selectors/CurrencySelectors';
import breakpoint from '../../utils/responsiveBreakpoints';
import { withRouter } from 'react-router-dom';
import SkeletonWrappedFormattedMessage from './SkeletonWrappedFormattedMessage';
import { FaqsAnswersTranslationsContext } from './Faq';
import { isMon606InAppRunningForPublicUserSelector, isMon606VariantSelector } from '../../selectors/ExperimentTreatmentSelectors';
import { getMon606TextKeyBase } from '../../utils/mon606Utils';
const QuestionContainer = styled.div.withConfig({
  displayName: "Question__QuestionContainer",
  componentId: "sc-1s2ky7s-0"
})(["margin-top:15px;margin-left:25px;margin-right:30px;background-color:", ";", ""], OLAF, breakpoint.phone(_t || (_t = _`
    margin: 15px 0 0;
  `)));
const QuestionOutlineBorder = styled(UIExpandableSection).withConfig({
  displayName: "Question__QuestionOutlineBorder",
  componentId: "sc-1s2ky7s-1"
})(["border-width:0 0.5px 0.5px 1px;border-style:solid;border-color:", ";"], BATTLESHIP);
const Br = styled.br.withConfig({
  displayName: "Question__Br",
  componentId: "sc-1s2ky7s-2"
})(["line-height:40px;"]);
const Bold = styled.span.withConfig({
  displayName: "Question__Bold",
  componentId: "sc-1s2ky7s-3"
})(["font-weight:bold;"]);

const Question = ({
  questionKey,
  href,
  externalLink = true,
  history,
  onClick,
  onQuestionClick,
  passedInOptions,
  isJSX = true
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const isMon606Variant = useSelector(isMon606VariantSelector);
  const isMon606InAppRunningForPublicUser = useSelector(isMon606InAppRunningForPublicUserSelector);
  const Mon606TextKeyBase = questionKey === 'free.whatIsAUser411' ? getMon606TextKeyBase(isMon606Variant) : 'pricingPage';

  const handleClickQuestion = question => {
    getUsageTracker().track('faqClickQuestionExpansion', {
      questionKey: question
    });
    onQuestionClick();
  };

  const handleClickLink = () => {
    if (onClick) {
      onClick();
    } else {
      getUsageTracker().track('externalLinkClick', {
        name: 'faq-click-link',
        url: href
      });

      if (!externalLink) {
        history.push(href);
        window.scrollTo(0, 0);
      }
    }
  };

  const QuestionLink = ({
    children
  }) => {
    return /*#__PURE__*/_jsx(UILink, {
      external: externalLink,
      href: externalLink ? href : undefined,
      onClick: handleClickLink,
      children: children
    });
  };

  if (isMon606InAppRunningForPublicUser && questionKey === 'free.whatIsAUser411') {
    return null;
  }

  return /*#__PURE__*/_jsx(QuestionContainer, {
    children: /*#__PURE__*/_jsx(QuestionOutlineBorder, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.faq.${questionKey}.question`
      }),
      onClick: (...partialArgs) => handleClickQuestion(questionKey, ...partialArgs),
      children: isJSX ? /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        MessageComponent: FormattedJSXMessage,
        translationsContext: FaqsAnswersTranslationsContext,
        message: `${Mon606TextKeyBase}.faq.${questionKey}.answer_jsx`,
        options: Object.assign({
          currencyCode
        }, passedInOptions),
        elements: {
          Link: QuestionLink,
          FormattedCurrency,
          FormattedNumber,
          UIList,
          UILink,
          Br,
          div: (_ref) => {
            let {
              children
            } = _ref,
                rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

            return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
              children: children
            }));
          },
          Bold
        }
      }) : /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        translationsContext: FaqsAnswersTranslationsContext,
        message: `pricingPage.faq.${questionKey}.answer`
      })
    })
  });
};

Question.propTypes = {
  questionKey: PropTypes.string.isRequired,
  href: PropTypes.string,
  externalLink: PropTypes.bool,
  history: PropTypes.object,
  onClick: PropTypes.func,
  passedInOptions: PropTypes.object,
  isJSX: PropTypes.bool,
  onQuestionClick: PropTypes.func
};
export default withRouter(Question);